import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { Row, Col, Input, Popover, Checkbox, Button } from 'antd';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';

import '../../assets/styles/common.css';
import {
  handelIncreaseTime,
  handelDecreaseTime,
  secondsToHms,
  checkInputWithColor,
  checkShowHideIcon,
  JPYs,
  handleShowHide,
  handleKeyPress,
  kouteiCalculateSelectedArr,
  handleCollpse,
} from '../common/Common.js';
import CurrencyInput from 'react-currency-input-field';
import { BsUsbC, BsX } from 'react-icons/bs';
import { WorkType, DataType } from '../common/enums';
import { timeHmsStr, amtEmptyStr, DataButton, helpCmt } from '../common/Constant';

const ParentKouteiCalculate_Kumitate = forwardRef((props, ref) => {
  const [isYousetsudetail, setIYousetsudetail] = useState(false);
  const [totalAmt, setTotalAmt] = useState('');
  const [totalTime, setTotalTime] = useState('');
  const [totalSagyoAmt, setTotalSagyoAmt] = useState('');
  const [totalSagyoTime, setTotalSagyoTime] = useState('');
  const [totalSum, setTotalSum] = useState('');
  const [totalTimeSum, setTotalTimeSum] = useState('');
  const [sagyoAmtSum, setSagyoAmtSum] = useState('');
  const [sagyoTimeSum, setSagyoTimeSum] = useState('');
  const [orgData, setOrgData] = useState([]);
  const [editData, setEditData] = useState([]);
  const [deviceMst, setDeviceMst] = useState([]);
  const [processMst, setProcessMst] = useState([]);
  const [patternInfo, setPatternInfo] = useState([]);
  const [oldEditedData, setOldEditedData] = useState([]);
  const [updateEditedData, setUpdateEditedData] = useState([]);
  const [kumitateAmt, setKumitateAmt] = useState(0);

  const calculateTotals = (editDataArr) => {
    let sagyoTimeSum = 0;
    let sagyoAmtSum = 0;
    editDataArr?.forEach((element) => {
      sagyoAmtSum += element.sagyoAmt ? Math.round(element.sagyoAmt) : 0;
      sagyoTimeSum += element.sagyoTime;
    });

    let totalSum =
      (sagyoAmtSum ? Math.round(sagyoAmtSum) : 0) +
      (editDataArr[0].dandoriAmt ? Math.round(editDataArr[0].dandoriAmt) : 0); // 画面表示用（四捨五入した金額を足す）
    let totalTimeSum = sagyoTimeSum + editDataArr[0].dandoriTime;

    let totals = [];
    let i = 0;
    totals.push({
      id: i++,
      sagyoAmtSum: sagyoAmtSum,
      sagyoTimeSum: sagyoTimeSum,
      totalSum: totalSum,
      totalTimeSum: totalTimeSum,
    });
    return totals;
  };

  useEffect(() => {
    if (props?.activeTabKey === '4' || props.isReCal) {
      let editData = [];
      let totals = [];
      setKumitateAmt(0);
      /* setDandoriTimeSum(0);
    setDandoriAmtSum(0); */
      setSagyoTimeSum(0);
      setSagyoAmtSum(0);
      setTotalSum(0);
      setTotalTimeSum(0);

      setTotalAmt(0);
      setTotalTime(0);
      setTotalSagyoAmt(0);
      setTotalSagyoTime(0);

      let parameters = props?.selectedDataDetail?.estimateProducts?.calcParameters?.parameters;
      let processMst = parameters?.process
        ? parameters.process?.filter((item) => item.workType === WorkType.PaAssenble)[0]
        : [];
      let assenbleAdditions = props?.selectedDataDetail?.estimateProducts?.additions?.filter(
        (item) => item.processId == processMst?.id
      )[0];
      // IQX_WEBEST-16 工程積算タブで編集データのチェックがOFFだと、手入力で入力した内容がリセットされてしまう
      let assenbleAdditionsEditData = assenbleAdditions?.editItems;
      let editDataFlg = assenbleAdditions?.editDataFlg;
      let patternInfo = props?.selectedDataDetail?.estimateProducts?.processSelect
        ? props?.selectedDataDetail?.estimateProducts?.processSelect?.details?.filter(
            (item) => item.processId == processMst?.id
          )
        : [];
      setPatternInfo([]);
      if (patternInfo == undefined) return;
      if (patternInfo?.length > 0 && patternInfo[0]?.isUsedForCalc == false) return;
      let deviceMst =
        parameters?.device && patternInfo
          ? parameters?.device?.filter(
              (item) => item.processId == patternInfo[0]?.processId && item.id == patternInfo[0]?.deviceId
            )[0]
          : []; //テスト用ID;
      setProcessMst(processMst ? processMst : []);
      setDeviceMst(deviceMst ? deviceMst : []);
      setPatternInfo(patternInfo);
      // 新規の場合
      /* if (assenbleAdditions == undefined) { */
      let assenbleAddition = {};
      let detailItems = [];
      let editDetailItems = [];
      let processCount = 0;
      let processName = '基本合計組立金額/時間';
      let processTime = 0;

      // 基本合計組立情報
      detailItems.push({
        id: 1,
        processName: processName,
        dandoriAmt: 0,
        dandoriTime: 0,
        sagyoAmt: 0,
        sagyoTime: 0,
        processCount: processCount,
        processTime: processTime,
        kihon: true,
        formula: '',
        purchaseId: 0,
      });

      // 購入品の合計組立金額/時間
      let purchases = props?.selectedDataDetail?.estimateProducts?.purchases;
      for (let j = 0; j < purchases?.length; j++) {
        let purchase = purchases[j];
        if (purchase.processTime > 0) {
          detailItems.push({
            id: j + 2,
            processName: '【' + purchase.name + '】合計組立金額/時間',
            dandoriAmt: 0,
            dandoriTime: 0,
            sagyoAmt: 0,
            sagyoTime: 0,
            processCount: purchase.required,
            processTime: purchase.processTime,
            kihon: false,
            formula: '',
            purchaseId: purchase.purchaseId,
          });
        }
      }

      let id = 1;
      if (props?.selectedDataDetail?.estimateProducts?.additions?.length > 0) {
        let lastRecord = props?.selectedDataDetail?.estimateProducts?.additions?.sort((a, b) => b.no - a.no)?.[0];
        id = lastRecord?.no + 1;
      }
      assenbleAddition = {
        no: processMst?.id,
        processId: processMst?.id,
        dataType: assenbleAdditions?.dataType ? assenbleAdditions.dataType : DataType.Data,
        dataItems: detailItems,
        editItems: editDetailItems,
        totalDandori: {
          dataItemsAmt: 0,
          dataItemsTime: 0,
          editItemsAmt: 0,
          editItemsTime: 0,
        },
        totalSagyo: {
          dataItemsAmt: 0,
          dataItemsTime: 0,
          editItemsAmt: 0,
          editItemsTime: 0,
        },
        totalDataPrice: 0,
        totalDataTime: 0,
        totalEditPrice: 0,
        totalEditTime: 0,
        editDataFlg: editDataFlg,
      };
      assenbleAdditions = assenbleAddition;
      /* } */
      // 購入品の合計組立金額/時間
      // let purchases = props?.selectedDataDetail?.estimateProducts?.purchases;
      let purchaseDetailItems = [];
      purchaseDetailItems.push(assenbleAdditions.dataItems[0]);
      for (let j = 0; j < purchases?.length; j++) {
        let purchase = purchases[j];
        if (purchase.isDeleted) continue;
        let isPurchase = assenbleAdditions.dataItems?.filter((item) => item.purchaseId == purchase.purchaseId);
        let lastRow = assenbleAdditions.dataItems?.sort((a, b) => b.no - a.no)?.[0];
        if (purchase.processTime > 0) {
          //追加された購入品の場合
          if (isPurchase?.length == 0) {
            purchaseDetailItems.push({
              id: lastRow.id + 1,
              processName: '【' + purchase.name + '】合計組立金額/時間',
              dandoriAmt: 0,
              dandoriTime: 0,
              sagyoAmt: 0,
              sagyoTime: 0,
              processCount: purchase.required,
              processTime: purchase.processTime,
              kihon: false,
              formula: '',
              purchaseId: purchase.purchaseId,
            });
          } else {
            purchaseDetailItems.push(isPurchase[0]);
          }
        }
      }
      //購入品情報の更新
      assenbleAdditions.dataItems = purchaseDetailItems;
      if (assenbleAdditions?.dataItems) {
        let orgData = JSON.parse(JSON.stringify(assenbleAdditions?.dataItems));
        setOrgData(JSON.parse(JSON.stringify(assenbleAdditions?.dataItems)));
        setEditData(JSON.parse(JSON.stringify(assenbleAdditions?.dataItems)));
        if (deviceMst != undefined && orgData?.length > 0) {
          let assenbleProcessInput =
            props?.selectedDataDetail?.estimateProducts?.processInput?.assenbleProcessInputInfo;
          //部品数
          let partCnt = Number(assenbleProcessInput?.smPartsCount);
          orgData[0].processCount = partCnt;
          assenbleAdditions.dataItems[0].processCount = partCnt;
          // 基本情報の総重量
          let weight = props?.selectedDataDetail?.estimateProducts?.totalWeight;
          //総重量が0、子部品数が0の場合、段取と加工を計算しない。
          if (weight === 0 && partCnt === 0) {
            /** 段取金額/時間 */
            orgData[0].dandoriTime = 0;
            assenbleAdditions.dataItems[0].dandoriTime = 0;
            // 段取金額設定
            orgData[0].dandoriAmt = 0;
            assenbleAdditions.dataItems[0].dandoriAmt = 0;

            /** 作業金額/時間 */
            // 作業時間
            for (let i = 0; i < orgData?.length; i++) {
              //　組立時間
              orgData[i].processTime = 0;
              assenbleAdditions.dataItems[i].processTime = 0;
              orgData[i].sagyoTime = 0;
              // 作業金額
              orgData[i].sagyoAmt = 0;
              assenbleAdditions.dataItems[i].sagyoAmt = 0;
            }
            setSagyoTimeSum(0);
            setSagyoAmtSum(0);
            setTotalSum(0);
            setTotalTimeSum(0);
            assenbleAdditions.totalDataPrice = 0;
            assenbleAdditions.totalDandori.dataItemsAmt = 0;
            assenbleAdditions.totalSagyo.dataItemsAmt = 0;
            assenbleAdditions.totalDataTime = 0;
            assenbleAdditions.totalDandori.dataItemsTime = 0;
            assenbleAdditions.totalSagyo.dataItemsTime = 0;
          } else {
            /** 段取金額/時間 */
            // 段取時間設定
            //　基本段取時間＊部品点数＊重量係数
            let dandoriTimeSec = calDandoriTime(partCnt, deviceMst, weight);
            orgData[0].dandoriTime = dandoriTimeSec ? dandoriTimeSec : 0;
            assenbleAdditions.dataItems[0].dandoriTime = dandoriTimeSec ? dandoriTimeSec : 0;

            // 段取金額設定
            //段階時間＊時間チャージ
            let dandoriAmt = calDandoriAmt(dandoriTimeSec, deviceMst);
            orgData[0].dandoriAmt = dandoriAmt ? dandoriAmt : 0;
            assenbleAdditions.dataItems[0].dandoriAmt = dandoriAmt ? dandoriAmt : 0;

            // 1部品当たりの作業時間
            let mWorkHTime = deviceMst?.details?.workBasicTime;

            /** 作業金額/時間 */
            // 作業時間
            let sagyoTimeTotal = 0;
            let cSagyoAmtKumitateTotal = 0;
            for (let i = 0; i < orgData?.length; i++) {
              let detailItem = orgData[i];
              let sagyoTimeSec = 0;
              // 基本作業の場合
              if (detailItem.kihon) {
                // 1部品当たりの作業時間＊部品数＊重量係数
                sagyoTimeSec = calSagyoTime(partCnt, mWorkHTime, deviceMst, weight);
                //　組立時間
                orgData[i].processTime = mWorkHTime ? mWorkHTime : 0;
                assenbleAdditions.dataItems[i].processTime = mWorkHTime ? mWorkHTime : 0;
              } else {
                //　購入品とその他作業の場合
                //  購入品名の組立時間
                let kumitateTimeSec = detailItem?.processTime ? detailItem?.processTime : 0;
                // 数量（購入品必要数）
                let suryo = detailItem?.processCount ? detailItem?.processCount : 0;
                // 購入品名の組立時間＊数量（購入品必要数）
                sagyoTimeSec = kumitateTimeSec * suryo;
                //　組立時間
                orgData[i].processTime = kumitateTimeSec;
                assenbleAdditions.dataItems[i].processTime = kumitateTimeSec;
              }
              let sagyoTime = sagyoTimeSec;
              sagyoTime = sagyoTime ? sagyoTime : 0;
              orgData[i].sagyoTime = sagyoTime;
              assenbleAdditions.dataItems[i].sagyoTime = sagyoTime;
              sagyoTimeTotal = sagyoTimeTotal + sagyoTime;

              // 作業金額
              //　作業時間＊時間チャージ
              let cSagyoAmtKumitate = calSagyoAmt(sagyoTime, deviceMst);
              orgData[i].sagyoAmt = cSagyoAmtKumitate;
              assenbleAdditions.dataItems[i].sagyoAmt = cSagyoAmtKumitate;
              cSagyoAmtKumitateTotal = cSagyoAmtKumitateTotal + cSagyoAmtKumitate;
            }
            setSagyoTimeSum(sagyoTimeTotal);
            setSagyoAmtSum(cSagyoAmtKumitateTotal);

            let totalSum =
              (dandoriAmt ? Math.round(dandoriAmt) : 0) +
              (cSagyoAmtKumitateTotal ? Math.round(cSagyoAmtKumitateTotal) : 0); // 画面表示用（四捨五入した金額を足す）
            setTotalSum(totalSum ? totalSum : 0);
            assenbleAdditions.totalDataPrice = totalSum ? totalSum : 0;
            assenbleAdditions.totalDandori.dataItemsAmt = dandoriAmt ? Math.round(dandoriAmt) : 0;
            assenbleAdditions.totalSagyo.dataItemsAmt = cSagyoAmtKumitateTotal ? Math.round(cSagyoAmtKumitateTotal) : 0;

            let totalTimeSec = dandoriTimeSec + sagyoTimeTotal;
            setTotalTimeSum(totalTimeSec ? totalTimeSec : 0);
            assenbleAdditions.totalDataTime = totalTimeSec ? totalTimeSec : 0;
            assenbleAdditions.totalDandori.dataItemsTime = dandoriTimeSec ? dandoriTimeSec : 0;
            assenbleAdditions.totalSagyo.dataItemsTime = sagyoTimeTotal ? sagyoTimeTotal : 0;
          }
          setOrgData(orgData);

          // IQX_WEBEST-16 工程積算タブで編集データのチェックがOFFだと、手入力で入力した内容がリセットされてしまう
          if (assenbleAdditionsEditData?.length > 0 && editDataFlg) {
            editData = JSON.parse(JSON.stringify(assenbleAdditionsEditData));
          } else {
            editData = JSON.parse(JSON.stringify(orgData));
          }
          if (editData?.length > 0) {
            assenbleAdditions.editItems = editData;
            setEditData(editData);
            setOldEditedData(editData);
            totals = calculateTotals(editData);
            // 編集
            setTotalAmt(totals[0]?.totalSum);
            assenbleAdditions.totalEditPrice = totals[0]?.totalSum ? totals[0]?.totalSum : 0;
            assenbleAdditions.totalDandori.editItemsAmt = editData[0].dandoriAmt
              ? Math.round(editData[0].dandoriAmt)
              : 0;
            assenbleAdditions.totalSagyo.editItemsAmt = totals[0]?.sagyoAmtSum ? totals[0]?.sagyoAmtSum : 0;

            setTotalTime(totals[0]?.totalTimeSum ? totals[0]?.totalTimeSum : 0);
            assenbleAdditions.totalEditTime = totals[0]?.totalTimeSum ? totals[0]?.totalTimeSum : 0;
            assenbleAdditions.totalDandori.editItemsTime = editData[0].dandoriTime ? editData[0].dandoriTime : 0;
            assenbleAdditions.totalSagyo.editItemsTime = totals[0]?.sagyoTimeSum ? totals[0]?.sagyoTimeSum : 0;
            setTotalSagyoAmt(totals[0]?.sagyoAmtSum ? totals[0]?.sagyoAmtSum : 0);
            setTotalSagyoTime(totals[0]?.sagyoTimeSum ? totals[0]?.sagyoTimeSum : 0);
          }
          setKumitateAmt(
            assenbleAdditions?.dataType == DataType.Data
              ? assenbleAdditions.totalDataPrice
              : assenbleAdditions.totalEditPrice
          );
          setUpdateEditedData(assenbleAdditions);
          props?.updateKouteiCal(assenbleAdditions, WorkType.PaAssenble);
        }
      }
    }
  }, [
    props?.activeTabKey,
    props?.purchasesData,
    props?.selectedDataDetail,
    props?.activePartMenu,
    props.selectedDataDetail?.esIq3Info,
    props?.isReCal,
  ]);

  const kumitate = () => {
    if (isYousetsudetail == true) {
      setIYousetsudetail(false);
    } else {
      setIYousetsudetail(true);
    }
  };

  const childDetail = (i) => {
    let showHide = document.getElementById('childPartKumitate' + i).style.display;
    if (showHide == 'block') {
      document.getElementById('childPartKumitate' + i).style.display = 'none';
      document.getElementById('arrowUpChildKumitate' + i).style.display = 'none';
      document.getElementById('arrowDownChildKumitate' + i).style.display = 'block';
    } else {
      document.getElementById('childPartKumitate' + i).style.display = 'block';
      document.getElementById('arrowUpChildKumitate' + i).style.display = 'block';
      document.getElementById('arrowDownChildKumitate' + i).style.display = 'none';
    }
  };

  const handleChangeCheckData = (e, i) => {
    const editedData = { ...updateEditedData };
    editedData.dataType = e;
    setUpdateEditedData(editedData);
    setKumitateAmt(e == DataType.Data ? editedData.totalDataPrice : editedData.totalEditPrice);
    props?.updateKouteiCal(editedData, WorkType.PaAssenble);
  };

  // IQX_WEBEST-16 データ表示に戻す
  const settingDataItems = () => {
    updateEditedData.editItems = JSON.parse(JSON.stringify(updateEditedData?.dataItems));
    updateEditedData.editDataFlg = false;
    setEditData(JSON.parse(JSON.stringify(orgData)));
    setTotalSagyoAmt(sagyoAmtSum ? sagyoAmtSum : 0);
    setTotalSagyoTime(sagyoTimeSum ? sagyoTimeSum : 0);
    setTotalAmt(totalSum ? totalSum : 0);
    setTotalTime(totalTimeSum ? totalTimeSum : 0);
    updateEditedData.totalEditPrice = totalSum ? totalSum : 0;
    updateEditedData.totalEditTime = totalTimeSum ? totalTimeSum : 0;
    const cuDivs = document.querySelectorAll('div[id*="Cu"]');

    cuDivs.forEach((div) => {
      div.style.display = 'none';
    });

    if (updateEditedData.dataType == DataType.Data) {
      setKumitateAmt(updateEditedData.totalDataPrice);
    } else {
      setKumitateAmt(updateEditedData.totalEditPrice);
    }
    props?.updateKouteiCal(updateEditedData, WorkType.PaAssenble);
  };

  const settingNewDandoriAmtInArr = (value, indexj, objId, timeType, timeAct) => {
    let newState = [...editData];
    updateEditedData.editDataFlg = true; // IQX_WEBEST-16 編集データを保持フラグOn
    if (objId !== 'cDandoroTimeKumitate' && objId !== 'kumitateTotalDandoriAmtIn') {
      setOldEditedData(JSON.parse(JSON.stringify(newState)));
    }
    let oldValue;
    let oldChild = JSON.parse(JSON.stringify(newState[indexj]));
    let sagyoAmtSum = 0;
    let dandoriAmt = 0;
    let dandoriTimeSec = 0;
    let sagyoTimeSumSec = 0;
    let childSumArrState = [];
    let childPartArr = newState;
    if (value === undefined) {
      value = 0;
    } else {
      value = value ? Number(value) : 0;
    }

    let childPart = editData[indexj];
    if (indexj === '') {
      oldValue = JSON.parse(JSON.stringify(editData[indexj][objId]));
      newState[indexj][objId] = value;
    } else {
      oldValue = childPart[objId];
      if (timeType === '') {
        childPart[objId] = Number(value);
      } else {
        childPart[objId] = value;
      }
      newState[indexj] = childPart;
    }

    // 基本情報の総重量
    let weight = props?.selectedDataDetail?.estimateProducts?.totalWeight;
    if (objId === 'sagyoTime') {
      newState[indexj].sagyoTime = value ? Number(value) : 0;
      updateEditedData.editItems[indexj].sagyoTime = value ? value : 0;
      if (document.getElementById(indexj + 'cSagyoAmtKumitateCu').style.display !== undefined) {
        let showHideCu = document.getElementById(indexj + 'cSagyoAmtKumitateCu').style.display;
        if (showHideCu === 'block') {
          checkInputWithColor(true, '', indexj + 'cSagyoAmtKumitate', childPart.sagyoAmt, 'red');
        } else {
          if (value === 0) {
            newState[indexj].sagyoAmt = 0;
          } else if (timeAct === 'input') {
            let oldValue = oldChild[indexj];
            let timeType = value - oldValue.sagyoTime;
            childPart.sagyoAmt = changeAmtwithTime(newState[indexj].sagyoAmt, timeType, timeAct, value);
          } else {
            newState[indexj].sagyoAmt = changeAmtwithTime(newState[indexj].sagyoAmt, timeType, timeAct, value);
          }
          newState[indexj] = childPart;
          updateEditedData.editItems[indexj].sagyoAmt = newState[indexj].sagyoAmt ? newState[indexj].sagyoAmt : 0;
          /* checkInputWithColor(false,'',index'cSagyoAmtKumitate', newState[indexi].sagyoAmt, 'green'); */
          checkInputWithColor(true, '', indexj + 'cSagyoAmtKumitate', childPart.sagyoAmt, 'green');
        }
      }
    } else if (objId === 'sagyoAmt') {
      newState[indexj].sagyoAmt = value ? Number(value) : 0;
      updateEditedData.editItems[indexj].sagyoAmt = value ? value : 0;
    } else if (objId === 'processCount') {
      let sagyoTimeSec = 0;
      let sagyoTime = 0;
      newState[indexj].processCount = value ? Number(value) : 0;
      updateEditedData.editItems[indexj].processCount = value ? value : 0;
      // 1部品当たりの作業時間＊部品数＊重量係数
      if (childPart.kihon) {
        // 段取時間設定
        let dandoriTimeSec = calDandoriTime(value, deviceMst, weight);
        let dandoriTimeHms = dandoriTimeSec;
        newState[indexj].dandoriTime = dandoriTimeHms;
        updateEditedData.editItems[indexj].dandoriTime = dandoriTimeSec ? dandoriTimeSec : 0;

        if (document.getElementById('kumitateTotalDandoriAmtCu').style.display !== undefined) {
          let showHideCu = document.getElementById('kumitateTotalDandoriAmtCu').style.display;
          if (showHideCu === 'none') {
            // 段取金額設定
            //段階時間＊時間チャージ
            let dandoriAmt = calDandoriAmt(dandoriTimeSec, deviceMst);
            newState[indexj].dandoriAmt = dandoriAmt;
            updateEditedData.editItems[indexj].dandoriAmt = dandoriAmt ? dandoriAmt : 0;
          }
        }

        // 作業時間
        //　基本段取時間＊部品点数＊重量係数
        sagyoTimeSec = calSagyoTime(value, deviceMst?.details?.workBasicTime, deviceMst, weight);
      } else {
        //　購入品とその他作業の場合
        //  購入品名の組立時間
        let purSagyoTimeSec = oldChild[indexj].processTime;
        // 数量（購入品必要数）
        let suryo = value;
        // 購入品名の組立時間＊数量（購入品必要数）
        sagyoTimeSec = purSagyoTimeSec * suryo;
      }
      sagyoTime = sagyoTimeSec;
      childPartArr[indexj].sagyoTime = sagyoTime ? sagyoTime : 0;
      updateEditedData.editItems[indexj].sagyoTime = sagyoTime ? sagyoTime : 0;
      // 作業金額
      //　加工時間＊時間チャージ
      if (document.getElementById(indexj + 'cSagyoAmtKumitateCu').style.display !== undefined) {
        let showHideCu = document.getElementById(indexj + 'cSagyoAmtKumitateCu').style.display;
        if (showHideCu === 'none') {
          childPartArr[indexj].sagyoAmt = calSagyoAmt(sagyoTime, deviceMst);
          updateEditedData.editItems[indexj].sagyoAmt = childPartArr[indexj].sagyoAmt
            ? childPartArr[indexj].sagyoAmt
            : 0;
        }
      }
    } else if (objId === 'processTime') {
      let workBasicTimeIn = value;
      let sagyoTimeSec = 0;
      let sagyoTime = 0;
      //1部品当たりの作業時間更新
      updateEditedData.editItems[indexj].processTime = value;
      if (childPart.kihon) {
        // 1部品当たりの作業時間＊部品数＊重量係数
        sagyoTimeSec = calSagyoTime(childPartArr[indexj].processCount, workBasicTimeIn, deviceMst, weight);
      } else {
        //　購入品とその他作業の場合
        // 数量（購入品必要数）
        let suryo = childPartArr[indexj].processCount;
        // 購入品名の組立時間＊数量（購入品必要数）
        sagyoTimeSec = workBasicTimeIn * suryo;
      }
      sagyoTime = sagyoTimeSec;
      childPartArr[indexj].sagyoTime = sagyoTime ? sagyoTime : 0;
      updateEditedData.editItems[indexj].sagyoTime = sagyoTime ? sagyoTime : 0;
      // 作業金額
      //　加工時間＊時間チャージ
      if (document.getElementById(indexj + 'cSagyoAmtKumitateCu').style.display !== undefined) {
        let showHideCu = document.getElementById(indexj + 'cSagyoAmtKumitateCu').style.display;
        if (showHideCu === 'none') {
          let sagyoAmtVal = calSagyoAmt(sagyoTime, deviceMst);
          childPartArr[indexj].sagyoAmt = sagyoAmtVal ? sagyoAmtVal : 0;
          updateEditedData.editItems[indexj].sagyoAmt = childPartArr[indexj].sagyoAmt
            ? childPartArr[indexj].sagyoAmt
            : 0;
        }
      }
    } else if (objId === 'dandoriAmt') {
      newState[0].dandoriAmt = value ? Number(value) : 0;
      updateEditedData.editItems[0].dandoriAmt = value ? value : 0;
    } else if (objId === 'dandoriTime') {
      newState[0].dandoriTime = value ? Number(value) : 0;
      updateEditedData.editItems[0].dandoriTime = value ? value : 0;
      // 段取金額設定
      //段階時間＊時間チャージ
      let dandoriAmtVal = calDandoriAmt(value, deviceMst);
      if (document.getElementById('kumitateTotalDandoriAmtCu').style.display !== undefined) {
        let showHideCu = document.getElementById('kumitateTotalDandoriAmtCu').style.display;
        if (showHideCu === 'none') {
          let dandoriAmt = dandoriAmtVal ? dandoriAmtVal : 0;
          newState[0].dandoriAmt = dandoriAmt ? dandoriAmt : 0;
          updateEditedData.editItems[0].dandoriAmt = dandoriAmt ? dandoriAmt : 0;
        }
      }
    }

    // データ更新
    dandoriAmt = newState[0].dandoriAmt ? newState[0].dandoriAmt : 0;
    dandoriTimeSec = newState[0].dandoriTime ? newState[0].dandoriTime : 0;
    for (let j = 0; j < childPartArr?.length; j++) {
      childSumArrState.push({
        id: j,
        dandoriAmt: dandoriAmt ? Math.round(dandoriAmt) : 0,
        dandoriTimeSec: dandoriTimeSec,
        dandoriTime: dandoriTimeSec,
        sagyoAmt: +childPartArr[j].sagyoAmt,
        sagyoTime: +childPartArr[j].sagyoTime,
        sagyoTimeSec: +childPartArr[j].sagyoTime,
        processCount: childPartArr[j].processCount,
        processTime: childPartArr[j].processTime,
        kihon: childPartArr[j].kihon,
      });
    }

    childSumArrState?.forEach((element) => {
      sagyoAmtSum += element.sagyoAmt ? Math.round(element.sagyoAmt) : 0;
      sagyoTimeSumSec += element.sagyoTime;
    });

    let totalSum = (sagyoAmtSum ? Math.round(sagyoAmtSum) : 0) + (dandoriAmt ? Math.round(dandoriAmt) : 0); // 画面表示用（四捨五入した金額を足す）
    let totalTimeSumSec = sagyoTimeSumSec + dandoriTimeSec;
    let sagyoTimeSum = sagyoTimeSumSec;

    setTotalSagyoAmt(sagyoAmtSum ? sagyoAmtSum : 0);
    setTotalSagyoTime(sagyoTimeSum ? sagyoTimeSum : 0);
    setTotalAmt(totalSum ? totalSum : 0);
    setTotalTime(totalTimeSumSec ? totalTimeSumSec : 0);
    updateEditedData.totalEditPrice = totalSum ? totalSum : 0;
    updateEditedData.totalEditTime = totalTimeSumSec ? totalTimeSumSec : 0;

    updateEditedData.totalDandori.editItemsAmt = dandoriAmt ? dandoriAmt : 0;
    updateEditedData.totalDandori.editItemsTime = dandoriTimeSec ? dandoriTimeSec : 0;
    updateEditedData.totalSagyo.editItemsAmt = sagyoAmtSum ? sagyoAmtSum : 0;
    updateEditedData.totalSagyo.editItemsTime = sagyoTimeSumSec ? sagyoTimeSumSec : 0;

    setEditData(childSumArrState);
    if (updateEditedData.dataType == DataType.Data) {
      setKumitateAmt(updateEditedData.totalDataPrice);
    } else {
      setKumitateAmt(updateEditedData.totalEditPrice);
    }
    props?.updateKouteiCal(updateEditedData, WorkType.PaAssenble);
  };

  const calSagyoTime = (partCntIn, workBasicTime, deviceMst, weight) => {
    // 作業時間
    // 重量係数
    let prepCoeffThWeights = deviceMst?.details?.prepCoeffThWeightMaster?.filter(
      (item) => (item.value == weight || item.value > weight) && !item.isOutOfRange
    );
    let prepCoeffThWeightNo =
      prepCoeffThWeights?.length > 0 ? prepCoeffThWeights[0]?.no : deviceMst?.details?.prepCoeffThWeightMaster[0]?.no;
    let prepCoeffThWeight =
      prepCoeffThWeightNo == 0
        ? 0
        : deviceMst?.details?.prepCoeffThWeightItems?.filter(
            (item) => item.no == prepCoeffThWeightNo && !item.isOutOfRange
          )[0]?.value;
    // 1部品当たりの作業時間＊部品数＊重量係数
    let cSagyoTimeKensaSec = workBasicTime * partCntIn * prepCoeffThWeight;
    cSagyoTimeKensaSec = cSagyoTimeKensaSec ? cSagyoTimeKensaSec : 0;
    cSagyoTimeKensaSec = cSagyoTimeKensaSec * getProductionQuantityCoeff(deviceMst); // IQX_WEBEST-278 作業時間＊生産個数係数
    return cSagyoTimeKensaSec;
  };

  const calSagyoAmt = (cSagyoTimeKensaSec, deviceMst) => {
    // 作業金額
    // 1部品当たりの作業時間
    let mWorkHTime = cSagyoTimeKensaSec;
    let mWorkHTimeMin = mWorkHTime / 60;
    //装置の作業時間チャージ
    let mWorkHRate = deviceMst?.details?.charges.work;
    //　加工時間＊時間チャージ
    let cSagyoAmtKensa = (mWorkHTimeMin * mWorkHRate) / 60.0;
    cSagyoAmtKensa = Number.isFinite(cSagyoAmtKensa) ? cSagyoAmtKensa : 0;
    return cSagyoAmtKensa;
  };

  const calDandoriTime = (partCnt, deviceMst, weight) => {
    if (partCnt == 0) return 0;
    // 段取時間設定
    // 重量係数
    let mBendCoeffMsts = deviceMst?.details?.prepCoeffThWeightMaster?.filter(
      (item) => (item.value == weight || item.value > weight) && !item.isOutOfRange
    );
    let mBendCoeffMstNo =
      mBendCoeffMsts?.length > 0 ? mBendCoeffMsts[0]?.no : deviceMst?.details?.prepCoeffThWeightMaster[0]?.no;
    let mBendCoeff =
      mBendCoeffMstNo == 0
        ? 0
        : deviceMst?.details?.prepCoeffThWeightItems?.filter(
            (item) => item.no == mBendCoeffMstNo && !item.isOutOfRange
          )[0]?.value;
    // 部品点数
    let prepThQtyMasters = deviceMst?.details?.prepThQtyMaster?.filter(
      (item) => item.value == partCnt || item.value > partCnt
    );
    let buhinCntNo =
      prepThQtyMasters?.length > 0 ? prepThQtyMasters[0]?.no : deviceMst?.details?.prepThQtyMaster[0]?.no;
    let buhinCnt =
      buhinCntNo == 0
        ? 0
        : deviceMst?.details?.prepCoeffThChildQtyItems?.filter((item) => item.no == buhinCntNo && !item.isOutOfRange)[0]
            ?.value;
    //　基本段取時間＊重量係数＊部品点数
    let dandoriTimeSec = deviceMst?.details?.prepBasicTime * mBendCoeff * buhinCnt;
    dandoriTimeSec = dandoriTimeSec ? dandoriTimeSec : 0;
    return dandoriTimeSec;
  };

  const calDandoriAmt = (dandoriTimeSec, deviceMst) => {
    //段階時間
    let mSetTimeMin = dandoriTimeSec / 60;
    //装置の段階時間チャージ
    let mSetHRate = deviceMst?.details?.charges.prep;
    //段階時間＊時間チャージ
    let dandoriAmt = (mSetTimeMin * mSetHRate) / 60.0;
    dandoriAmt = dandoriAmt ? dandoriAmt : 0;
    return dandoriAmt;
  };

  const checkStr = (val) => {
    let intAmt;
    if (val === '') {
      intAmt = 0;
    } else if (typeof val === 'string') {
      intAmt = Number(val.charAt(0) == '¥' ? val.replace('¥', '') : val);
    } else intAmt = val;
    intAmt = intAmt ? intAmt : 0;
    return intAmt;
  };

  const changeAmtwithTime = (amt, typeTime, action, timeVal) => {
    let editedAmt;
    let totalSec = Number(timeVal);
    let intAmt = checkStr(amt);

    if (action === 'input') {
      editedAmt = intAmt + typeTime;
    } else {
      // 作業金額
      //　加工時間＊時間チャージ
      editedAmt = calSagyoAmt(totalSec, deviceMst);
    }
    editedAmt = editedAmt ? editedAmt : 0;
    return editedAmt;
  };

  const setKumitateDisplay = (display) => {
    setIYousetsudetail(display);
  };

  useImperativeHandle(ref, () => ({
    getKouteiCalInfoAssemble: () => {
      return updateEditedData;
    },
    setKumitateDisplay: setKumitateDisplay,
  }));

  // IQX_WEBEST-278 工程積算タブの表示に生産個数係数が含まれていなかったので、含むようにしてほしい
  const getProductionQuantityCoeff = (deviceMst) => {
    let productionQuantityCoeff = 1;
    let quantity = props?.selectedDataDetail?.estimateProducts?.quantity;
    // 生産個数係数
    let productionCoeffTh = deviceMst?.details?.productionQtyCoeffThMaster?.filter(
      (item) => (item.value == quantity || item.value > quantity) && !item.isOutOfRange
    );
    if (productionCoeffTh) {
      let productionCoeffThNo =
        productionCoeffTh?.length > 0
          ? productionCoeffTh[0]?.no
          : deviceMst?.details?.productionQtyCoeffThMaster?.[0]?.no;
      let productionCoeff =
        productionCoeffThNo == 0
          ? 0
          : deviceMst?.details?.productionQtyCoeffThItems?.filter(
              (item) => item.no == productionCoeffThNo && !item.isOutOfRange
            )[0]?.value;

      productionQuantityCoeff = productionCoeff ? productionCoeff : 1;
    }
    return productionQuantityCoeff;
  };

  return (
    <>
      {props?.activeTabKey === '4' ? (
        <div className="kouteiCalculateDiv" style={{ display: patternInfo?.length > 0 ? 'block' : 'none' }}>
          <Row style={{ color: 'black' }} className="oyabuhin oyabuhin-row " onClick={kumitate}>
            <Col span={4} className="oyabuhin-col">
              <div style={{ display: 'flex' }}>
                {isYousetsudetail ? (
                  <CaretUpOutlined style={{ fontSize: 17, marginTop: 2 }} />
                ) : (
                  <CaretDownOutlined style={{ fontSize: 17, marginTop: 2 }} />
                )}
                <label style={{ marginLeft: 5 }}>{processMst?.name}</label>
              </div>
            </Col>
            <Col span={6} className="oyabuhin-col">
              <div>{kumitateAmt ? JPYs.format(Math.round(kumitateAmt)) : amtEmptyStr}</div>
            </Col>
            <Col span={13} style={{ border: 'none' }} className="oyabuhin-col">
              <div>
                <label style={{ marginLeft: 5 }}>{deviceMst?.name}</label>
              </div>
            </Col>
          </Row>
          <div style={{ display: isYousetsudetail ? 'block' : 'none' }}>
            <Row style={{ color: 'black' }} className="oyabuhin-detail oyabuhin-row">
              <Col span={4} className="oyabuhin-detail-col">
                工程詳細
              </Col>
              <Col span={6} className="oyabuhin-detail-col">
                <Checkbox
                  key={kouteiCalculateSelectedArr[0].key}
                  value={kouteiCalculateSelectedArr[0].value}
                  checked={kouteiCalculateSelectedArr[0].key == updateEditedData.dataType}
                  disabled={!props?.editMode}
                  style={{ marginRight: 6 }}
                  onChange={(e) => props?.editMode && handleChangeCheckData(kouteiCalculateSelectedArr[0].key)}
                ></Checkbox>
                <label>{kouteiCalculateSelectedArr[0].value}</label>
              </Col>
              <Col span={8} className="oyabuhin-detail-col">
                <div style={{ display: 'flex', justifyContent: 'left', width: '60%' }}>
                  <Checkbox
                    key={kouteiCalculateSelectedArr[1].key}
                    value={kouteiCalculateSelectedArr[1].value}
                    disabled={!props?.editMode}
                    onChange={(e) => props?.editMode && handleChangeCheckData(kouteiCalculateSelectedArr[1].key)}
                    checked={kouteiCalculateSelectedArr[1].key == updateEditedData.dataType}
                    style={{ marginRight: 6 }}
                  ></Checkbox>
                  <label>{kouteiCalculateSelectedArr[1].value}</label>
                </div>
                <div style={{ display: 'flex', justifyContent: 'right', width: '40%' }}>
                  <Button onClick={settingDataItems} className="dataButton" id="dataBtn1">
                    {DataButton}
                  </Button>
                </div>
              </Col>
              <Col span={1} className="oyabuhin-detail-col">
                単位
              </Col>
              <Col span={5} className="formula-column">
                計算式
              </Col>
            </Row>
            <Row style={{ color: 'black' }} className="oyabuhin-detail oyabuhin-row">
              <Col span={4} className="oyabuhin-detail-col">
                {processMst?.name}
              </Col>
              <Col span={3} className="oyabuhin-detail-col">
                <label id="kumitateTotalAmt">{totalSum ? JPYs.format(Math.round(totalSum)) : amtEmptyStr}</label>
              </Col>
              <Col span={3} className="oyabuhin-detail-col">
                <label id="kumitateTotalTime">{totalTimeSum ? secondsToHms(totalTimeSum) : timeHmsStr}</label>
              </Col>
              <Col span={4} className="oyabuhin-detail-col">
                <label
                  id="kumitateTotalAmtIn"
                  className="resetColor"
                  style={{ color: Math.round(totalSum) === Math.round(totalAmt) ? 'black' : '#4cc12f' }}
                >
                  {totalAmt ? JPYs.format(Math.round(totalAmt)) : amtEmptyStr}
                </label>
              </Col>
              <Col span={4} className="oyabuhin-detail-col">
                <label
                  id="kumitateTotalTimeIn"
                  className="resetColor"
                  style={{ color: totalTimeSum === totalTime ? 'black' : '#4cc12f' }}
                >
                  {totalTime ? secondsToHms(totalTime) : timeHmsStr}
                </label>
              </Col>
              <Col span={1} className="oyabuhin-detail-col"></Col>
              <Col span={2} className="formula-column formula-column-right-border">
                <Popover content={helpCmt.procTotalAmt}>金額</Popover>
              </Col>
              <Col span={2} className="formula-column">
                <Popover content={helpCmt.procTotalTm}>時間</Popover>
              </Col>
            </Row>

            <Row style={{ color: 'black' }} className="oyabuhin-detail oyabuhin-row">
              <Col span={4} className="oyabuhin-detail-col">
                段取金額/時間
              </Col>
              <Col span={3} className="oyabuhin-detail-col">
                <label id="kumitateTotalDandoriAmt">
                  {orgData[0]?.dandoriAmt ? JPYs.format(Math.round(orgData[0]?.dandoriAmt)) : amtEmptyStr}
                </label>
              </Col>
              <Col span={3} className="oyabuhin-detail-col">
                <label id="kumitateTotalDandoriTime">
                  {orgData[0]?.dandoriTime ? secondsToHms(orgData[0]?.dandoriTime) : timeHmsStr}
                </label>
              </Col>
              <Col span={4} className="input-col">
                <CurrencyInput
                  id={'kumitateTotalDandoriAmtIn'}
                  value={editData[0]?.dandoriAmt ? Math.round(editData[0]?.dandoriAmt) : 0}
                  defaultValue={0}
                  onValueChange={(e) => {
                    if (editData[0]?.dandoriAmt != e) {
                      settingNewDandoriAmtInArr(e, 0, 'dandoriAmt', '', '');
                      checkInputWithColor(false, '', 'kumitateTotalDandoriAmt', e, 'amt');
                    }
                  }}
                  style={{
                    border: 'none',
                    color:
                      Math.round(orgData[0]?.dandoriAmt) === Math.round(editData[0]?.dandoriAmt)
                        ? 'black'
                        : checkShowHideIcon('kumitateTotalDandoriAmtCu') === 'none'
                        ? '#4cc12f'
                        : 'red',
                  }}
                  className={
                    props?.editMode ? 'input-editable currency resetColor' : 'input-non-editable currency resetColor'
                  }
                  prefix="¥"
                  decimalsLimit={100}
                />
                <div id={'kumitateTotalDandoriAmtCu'} style={{ display: 'none' }} className="currencyReset">
                  <div className="currencyIcon">
                    <BsUsbC style={{ fontSize: '25' }} />
                    <BsX style={{ margin: '-8px 0 0 16px' }} />
                    <span class="tooltiptext">
                      {/* 2025-6-26 IQX_WEBEST-425 テキスト修正  */}
                      {/* 金額に変更がありましたので、以降時間と連携して自動計算されない。 */}
                      金額を編集すると時間の自動計算が行われません。
                    </span>
                  </div>
                </div>
              </Col>
              <Col span={4} className="input-col">
                <Row style={{ width: '100%' }}>
                  <Col className="timer-input-col">
                    <Input
                      value={editData[0]?.dandoriTime ? secondsToHms(editData[0]?.dandoriTime) : timeHmsStr}
                      id={'kumitateTotalDandoriTimeIn'}
                      style={{
                        width: '100%',
                        color:
                          orgData[0]?.dandoriTime === editData[0]?.dandoriTime
                            ? 'black'
                            : oldEditedData[0]?.processCount === editData[0]?.processCount
                            ? 'red'
                            : '#4cc12f',
                      }}
                      className={props?.editMode ? 'input-editable' : 'input-non-editable'}
                      onChange={(e) => {
                        //disableTimer('test');
                        settingNewDandoriAmtInArr(e.target.value, 0, 'dandoriTime', 'input', 'input');
                      }}
                    ></Input>
                  </Col>
                  <Col className="timer-button-col">
                    {props?.editMode ? (
                      <>
                        <CaretUpOutlined
                          style={{ fontSize: 17 + 'px' }}
                          onClick={() => {
                            let editedTime = handelIncreaseTime(
                              editData[0]?.dandoriTime,
                              '10min',
                              'cDandoroTimeKumitate'
                            );
                            settingNewDandoriAmtInArr(editedTime, 0, 'dandoriTime', '10min', 'inc');
                          }}
                        />
                        <CaretDownOutlined
                          style={{ fontSize: 17 + 'px', color: '#000' }}
                          onClick={() => {
                            let editedTime = handelDecreaseTime(
                              editData[0]?.dandoriTime,
                              '10min',
                              'cDandoroTimeKumitate'
                            );
                            settingNewDandoriAmtInArr(editedTime, 0, 'dandoriTime', '10min', 'dec');
                          }}
                        />
                        <CaretUpOutlined
                          style={{ fontSize: 17 + 'px', color: '#000' }}
                          onClick={() => {
                            let editedTime = handelIncreaseTime(
                              editData[0]?.dandoriTime,
                              'min',
                              'cDandoroTimeKumitate'
                            );
                            settingNewDandoriAmtInArr(editedTime, 0, 'dandoriTime', 'min', 'inc');
                          }}
                        />
                        <CaretDownOutlined
                          style={{ fontSize: 17 + 'px', color: '#000' }}
                          onClick={() => {
                            let editedTime = handelDecreaseTime(
                              editData[0]?.dandoriTime,
                              'min',
                              'cDandoroTimeKumitate'
                            );
                            settingNewDandoriAmtInArr(editedTime, 0, 'dandoriTime', 'min', 'dec');
                          }}
                        />
                        <CaretUpOutlined
                          style={{ fontSize: 17 + 'px', color: '#000' }}
                          onClick={() => {
                            let editedTime = handelIncreaseTime(
                              editData[0]?.dandoriTime,
                              'sec',
                              'cDandoroTimeKumitate'
                            );
                            settingNewDandoriAmtInArr(editedTime, 0, 'dandoriTime', 'sec', 'inc');
                          }}
                        />
                        <CaretDownOutlined
                          style={{ fontSize: 17 + 'px', color: '#000' }}
                          onClick={() => {
                            let editedTime = handelDecreaseTime(
                              editData[0]?.dandoriTime,
                              'sec',
                              'cDandoroTimeKumitate'
                            );
                            settingNewDandoriAmtInArr(editedTime, 0, 'dandoriTime', 'sec', 'dec');
                          }}
                        />
                      </>
                    ) : (
                      <></>
                    )}
                  </Col>
                </Row>
              </Col>
              <Col span={1} className="oyabuhin-detail-col"></Col>
              <Col span={2} className="formula-column formula-column-right-border">
                <Popover content={helpCmt.setupAmt_p1}>金額</Popover>
              </Col>
              <Col span={2} className="formula-column">
                <Popover content={helpCmt.setupTm_p2}>時間</Popover>
              </Col>
            </Row>

            <Row
              style={{ color: 'black' }}
              className="oyabuhin-detail oyabuhin-row"
              onClick={(e) => handleCollpse('KumitateSagyo')}
            >
              <Col span={4} className="oyabuhin-detail-col">
                <div style={{ display: 'flex', overflow: 'hidden' }}>
                  <CaretUpOutlined
                    id={'arrowUpKumitateSagyo'}
                    style={{ fontSize: 17, marginTop: 2, display: 'none' }}
                  />
                  <CaretDownOutlined id={'arrowDownKumitateSagyo'} style={{ fontSize: 17, marginTop: 2 }} />
                  <span className="kouteiCal-proc-title">作業金額/時間</span>
                </div>
              </Col>
              <Col span={3} className="oyabuhin-detail-col">
                <label id="kumitateTotalSagyoAmt">
                  {sagyoAmtSum ? JPYs.format(Math.round(sagyoAmtSum)) : amtEmptyStr}
                </label>
              </Col>
              <Col span={3} className="oyabuhin-detail-col">
                <label id="kumitateTotalSagyoTime">{sagyoTimeSum ? secondsToHms(sagyoTimeSum) : timeHmsStr}</label>
              </Col>
              <Col span={4} className="oyabuhin-detail-col">
                <label
                  id="kumitateTotalSagyoAmtIn"
                  className="resetColor"
                  style={{ color: totalSagyoAmt === sagyoAmtSum ? 'black' : '#4cc12f' }}
                >
                  {totalSagyoAmt ? JPYs.format(Math.round(totalSagyoAmt)) : amtEmptyStr}
                </label>
              </Col>
              <Col span={4} className="oyabuhin-detail-col">
                <label
                  id="kumitateTotalSagyoTimeIn"
                  className="resetColor"
                  style={{ color: totalSagyoTime === sagyoTimeSum ? 'black' : '#4cc12f' }}
                >
                  {totalSagyoTime ? secondsToHms(totalSagyoTime) : timeHmsStr}
                </label>
              </Col>
              <Col span={1} className="oyabuhin-detail-col"></Col>
              <Col span={2} className="formula-column formula-column-right-border">
                <Popover content={helpCmt.workAmt_p2}>金額</Popover>
              </Col>
              <Col span={2} className="formula-column">
                <Popover content={helpCmt.workTotalTm_kumitate}>時間</Popover>
              </Col>
            </Row>
            <div id={'divKumitateSagyo'} style={{ display: 'none' }}>
              {(() => {
                const subArr = [];
                for (let j = 0; j < orgData?.length; j++) {
                  <div>
                    {(() => {
                      subArr.push(
                        <div>
                          <Row style={{ color: 'black' }} className="oyabuhin-detail oyabuhin-row">
                            <Col span={4} className="oyabuhin-detail-col" onClick={(e) => childDetail(j)}>
                              <div style={{ display: 'flex', overflow: 'hidden', marginLeft: '20px' }}>
                                <CaretUpOutlined
                                  id={'arrowUpChildKumitate' + j}
                                  style={{ fontSize: 17, marginTop: 2, display: 'none' }}
                                />
                                <CaretDownOutlined
                                  id={'arrowDownChildKumitate' + j}
                                  style={{ fontSize: 17, marginTop: 2 }}
                                />
                                <span className="kouteiCal-proc-title" title={orgData[j]?.processName}>
                                  {orgData[j]?.processName}
                                </span>
                              </div>
                            </Col>
                            <Col span={3} className="oyabuhin-detail-col" onClick={(e) => childDetail(j)}>
                              <label id={j + 'cSagyoAmtKumitate'}>
                                {orgData[j]?.sagyoAmt ? JPYs.format(Math.round(orgData[j]?.sagyoAmt)) : amtEmptyStr}
                              </label>
                            </Col>
                            <Col span={3} className="oyabuhin-detail-col" onClick={(e) => childDetail(j)}>
                              <label id={'sagyoTime' + j}>
                                {orgData[j]?.sagyoTime ? secondsToHms(orgData[j]?.sagyoTime) : timeHmsStr}
                              </label>
                            </Col>
                            <Col span={4} className="input-col">
                              <CurrencyInput
                                id={j + 'cSagyoAmtKumitateIn'}
                                value={editData[j]?.sagyoAmt ? Math.round(editData[j]?.sagyoAmt) : 0}
                                defaultValue={0}
                                onValueChange={(e) => {
                                  if (editData[j]?.sagyoAmt != e) {
                                    settingNewDandoriAmtInArr(e, j, 'sagyoAmt', '', '');
                                    checkInputWithColor(false, '', j + 'cSagyoAmtKumitate', e, 'amt');
                                  }
                                }}
                                style={{
                                  border: 'none',
                                  color:
                                    Math.round(orgData[j]?.sagyoAmt) === Math.round(editData[j]?.sagyoAmt)
                                      ? 'black'
                                      : checkShowHideIcon(j + 'cSagyoAmtKumitateCu') === 'none'
                                      ? '#4cc12f'
                                      : 'red',
                                }}
                                className={
                                  props?.editMode
                                    ? 'input-editable currency resetColor'
                                    : 'input-non-editable currency resetColor'
                                }
                                prefix="¥"
                                decimalsLimit={100}
                              />
                              <div id={j + 'cSagyoAmtKumitateCu'} style={{ display: 'none' }} className="currencyReset">
                                <div className="currencyIcon">
                                  <BsUsbC style={{ fontSize: '25' }} />
                                  <BsX style={{ margin: '-8px 0 0 16px' }} />
                                  <span class="tooltiptext">
                                    {/* 2025-6-26 IQX_WEBEST-425 テキスト修正  */}
                                    {/* 金額に変更がありましたので、以降時間と連携して自動計算されない。 */}
                                    金額を編集すると時間の自動計算が行われません。
                                  </span>
                                </div>
                              </div>
                            </Col>
                            <Col span={4} className="input-col">
                              <Row style={{ width: '100%' }}>
                                <Col className="timer-input-col">
                                  <Input
                                    value={editData[j]?.sagyoTime ? secondsToHms(editData[j]?.sagyoTime) : timeHmsStr}
                                    id={'sagyoTime' + j + 'In'}
                                    style={{
                                      width: '100%',
                                      color:
                                        orgData[j]?.sagyoTime === editData[j]?.sagyoTime
                                          ? handleShowHide(
                                              Math.round(orgData[j]?.sagyoAmt),
                                              Math.round(editData[j]?.sagyoAmt),
                                              j + 'cSagyoAmtKumitateCu'
                                            )
                                          : oldEditedData[j]?.processCount === editData[j]?.processCount &&
                                            oldEditedData[j]?.processTime === editData[j]?.processTime
                                          ? 'red'
                                          : '#4cc12f',
                                    }}
                                    className={
                                      props?.editMode ? 'input-editable resetColor' : 'input-non-editable resetColor'
                                    }
                                    onChange={(e) => {
                                      //disableTimer('test');

                                      settingNewDandoriAmtInArr(e.target.value, j, 'sagyoTime', 'input', 'input');
                                    }}
                                  ></Input>
                                </Col>
                                <Col className="timer-button-col">
                                  {props?.editMode ? (
                                    <>
                                      <CaretUpOutlined
                                        style={{ fontSize: 17 + 'px' }}
                                        onClick={() => {
                                          let editedTime = handelIncreaseTime(
                                            editData[j]?.sagyoTime,
                                            '10min',
                                            'sagyoTime' + j
                                          );
                                          settingNewDandoriAmtInArr(editedTime, j, 'sagyoTime', '10min', 'inc');
                                        }}
                                      />
                                      <CaretDownOutlined
                                        style={{ fontSize: 17 + 'px', color: '#000' }}
                                        onClick={() => {
                                          let editedTime = handelDecreaseTime(
                                            editData[j]?.sagyoTime,
                                            '10min',
                                            'sagyoTime' + j
                                          );
                                          settingNewDandoriAmtInArr(editedTime, j, 'sagyoTime', '10min', 'dec');
                                        }}
                                      />
                                      <CaretUpOutlined
                                        style={{ fontSize: 17 + 'px', color: '#000' }}
                                        onClick={() => {
                                          let editedTime = handelIncreaseTime(
                                            editData[j]?.sagyoTime,
                                            'min',
                                            'sagyoTime' + j
                                          );
                                          settingNewDandoriAmtInArr(editedTime, j, 'sagyoTime', 'min', 'inc');
                                        }}
                                      />
                                      <CaretDownOutlined
                                        style={{ fontSize: 17 + 'px', color: '#000' }}
                                        onClick={() => {
                                          let editedTime = handelDecreaseTime(
                                            editData[j]?.sagyoTime,
                                            'min',
                                            'sagyoTime' + j
                                          );
                                          settingNewDandoriAmtInArr(editedTime, j, 'sagyoTime', 'min', 'dec');
                                        }}
                                      />
                                      <CaretUpOutlined
                                        style={{ fontSize: 17 + 'px', color: '#000' }}
                                        onClick={() => {
                                          let editedTime = handelIncreaseTime(
                                            editData[j]?.sagyoTime,
                                            'sec',
                                            'sagyoTime' + j
                                          );
                                          settingNewDandoriAmtInArr(editedTime, j, 'sagyoTime', 'sec', 'inc');
                                        }}
                                      />
                                      <CaretDownOutlined
                                        style={{ fontSize: 17 + 'px', color: '#000' }}
                                        onClick={() => {
                                          let editedTime = handelDecreaseTime(
                                            editData[j]?.sagyoTime,
                                            'sec',
                                            'sagyoTime' + j
                                          );
                                          settingNewDandoriAmtInArr(editedTime, j, 'sagyoTime', 'sec', 'dec');
                                        }}
                                      />
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </Col>
                              </Row>
                            </Col>
                            <Col span={1} className="oyabuhin-detail-col" onClick={(e) => childDetail(j)}></Col>
                            <Col
                              span={2}
                              className="formula-column formula-column-right-border"
                              onClick={(e) => childDetail(j)}
                            >
                              <Popover content={helpCmt.workAmt_p2}>金額</Popover>
                            </Col>
                            <Col span={2} className="formula-column" onClick={(e) => childDetail(j)}>
                              <Popover content={orgData[j]?.kihon ? helpCmt.workTm_p2 : helpCmt.workTm_p3}>
                                時間
                              </Popover>
                            </Col>
                          </Row>
                          <div id={'childPartKumitate' + j} style={{ display: 'none' }}>
                            <Row style={{ color: 'black' }} className="oyabuhin-detail oyabuhin-row">
                              <Col span={4} className="oyabuhin-detail-col">
                                <span className="ddl_2_noImg kouteiCal-proc-title" style={{ paddingLeft: '10px' }}>
                                  {orgData[j]?.kihon ? '部品数' : '個数'}/1つ当たりの組立時間
                                </span>
                              </Col>
                              <Col span={3} className="oyabuhin-detail-col">
                                <label id="processCount">{orgData[j]?.processCount}</label>
                              </Col>
                              <Col span={3} className="oyabuhin-detail-col">
                                <label id="processTime">
                                  {orgData[j]?.processTime ? secondsToHms(orgData[j]?.processTime) : timeHmsStr}
                                </label>
                              </Col>
                              <Col span={4} className="input-col">
                                <Input
                                  value={editData[j]?.processCount}
                                  id="processCountIn"
                                  min={0}
                                  className={props?.editMode ? 'input-editable' : 'input-non-editable '}
                                  controls={false}
                                  style={{
                                    width: '45%',
                                    border: 'none',
                                    color: orgData[j]?.processCount === editData[j]?.processCount ? 'black' : 'red',
                                  }}
                                  onKeyPress={(e) => {
                                    handleKeyPress(e, true);
                                  }}
                                  onChange={(e) => {
                                    settingNewDandoriAmtInArr(
                                      e.target.value ? parseInt(e.target.value) : 0,
                                      j,
                                      'processCount',
                                      '',
                                      ''
                                    );
                                  }}
                                />
                              </Col>
                              <Col span={4} className="input-col">
                                <Row style={{ width: '100%' }}>
                                  <Col className="timer-input-col">
                                    <Input
                                      value={
                                        editData[j]?.processTime ? secondsToHms(editData[j]?.processTime) : timeHmsStr
                                      }
                                      id={j + 'processTimeIn'}
                                      style={{
                                        width: '100%',
                                        color: orgData[j]?.processTime === editData[j]?.processTime ? 'black' : 'red',
                                      }}
                                      className={
                                        props?.editMode ? 'input-editable resetColor' : 'input-non-editable resetColor'
                                      }
                                      onChange={(e) => {
                                        settingNewDandoriAmtInArr(e.target.value, j, 'processTime', 'input', 'input');
                                      }}
                                    ></Input>
                                  </Col>
                                  <Col className="timer-button-col">
                                    {props?.editMode ? (
                                      <>
                                        <CaretUpOutlined
                                          style={{ fontSize: 17 + 'px' }}
                                          onClick={() => {
                                            let editedTime = handelIncreaseTime(
                                              editData[j]?.processTime,
                                              '10min',
                                              j + 'processTime'
                                            );
                                            settingNewDandoriAmtInArr(editedTime, j, 'processTime', '10min', 'inc');
                                          }}
                                        />
                                        <CaretDownOutlined
                                          style={{ fontSize: 17 + 'px', color: '#000' }}
                                          onClick={() => {
                                            let editedTime = handelDecreaseTime(
                                              editData[j]?.processTime,
                                              '10min',
                                              j + 'processTime'
                                            );
                                            settingNewDandoriAmtInArr(editedTime, j, 'processTime', '10min', 'dec');
                                          }}
                                        />
                                        <CaretUpOutlined
                                          style={{ fontSize: 17 + 'px' }}
                                          onClick={() => {
                                            let editedTime = handelIncreaseTime(
                                              editData[j]?.processTime,
                                              'min',
                                              j + 'processTime'
                                            );
                                            settingNewDandoriAmtInArr(editedTime, j, 'processTime', 'min', 'inc');
                                          }}
                                        />
                                        <CaretDownOutlined
                                          style={{ fontSize: 17 + 'px', color: '#000' }}
                                          onClick={() => {
                                            let editedTime = handelDecreaseTime(
                                              editData[j]?.processTime,
                                              'min',
                                              j + 'processTime'
                                            );
                                            settingNewDandoriAmtInArr(editedTime, j, 'processTime', 'min', 'dec');
                                          }}
                                        />
                                        <CaretUpOutlined
                                          style={{ fontSize: 17 + 'px' }}
                                          onClick={() => {
                                            let editedTime = handelIncreaseTime(
                                              editData[j]?.processTime,
                                              'sec',
                                              j + 'processTime'
                                            );
                                            settingNewDandoriAmtInArr(editedTime, j, 'processTime', 'sec', 'inc');
                                          }}
                                        />
                                        <CaretDownOutlined
                                          style={{ fontSize: 17 + 'px', color: '#000' }}
                                          onClick={() => {
                                            let editedTime = handelDecreaseTime(
                                              editData[j]?.processTime,
                                              'sec',
                                              j + 'processTime'
                                            );
                                            settingNewDandoriAmtInArr(editedTime, j, 'processTime', 'sec', 'dec');
                                          }}
                                        />
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </Col>
                                </Row>
                              </Col>

                              <Col span={1} className="oyabuhin-detail-col"></Col>
                              <Col span={2} className="formula-column"></Col>
                            </Row>
                          </div>
                        </div>
                      );
                      return subArr;
                    })()}
                  </div>;
                }
                return subArr;
              })()}
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  );
});

export default ParentKouteiCalculate_Kumitate;
